import { formatMoney } from '@shopify/theme-currency';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartTotals = () => {
  const {
    cart: { cart_level_discount_applications, total_price },
    miniCartData,
  } = useCartContext();

  let percentage = 0;

  const thresholdInCents = miniCartData.settings.freeShippingThreshold * 100;
  const difference = thresholdInCents - total_price;

  if (difference > 0) {
    percentage = (total_price * 100) / thresholdInCents;
  } else {
    percentage = 100;
  }

  return (
    <div class="space-y-1">
      <div class="type-body-base mt-5 flex justify-between">
        <p>{getTranslation('cart.subtotal')}</p>
        <p>{formatMoney(total_price, theme.moneyFormat)}</p>
      </div>

      <div class="type-body-base flex items-center justify-between">
        <p>{getTranslation('mini_cart.shipping')}</p>
        {percentage < 100 ? (
          <p class="type-body-small">
            {getTranslation('mini_cart.shipping_at_checkout')}
          </p>
        ) : (
          <p>{formatMoney(0, theme.moneyFormat)} (Free)</p>
        )}
      </div>

      {/* Discounts */}
      {cart_level_discount_applications.length > 0 && (
        <div class="mt-4 flex flex-col items-end space-y-2">
          {cart_level_discount_applications.map(item => (
            <div class="type-body-small">
              {item.title} (-
              {formatMoney(item.total_allocated_amount, theme.moneyFormat)})
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CartTotals;
